import { Button, Modal } from '@bami-libs/uikit'
import BigNumber from 'bignumber.js'
import ModalActions from 'components/ModalActions'
import TokenInput from 'components/TokenInput'
import useI18n from 'hooks/useI18n'
import React, { useCallback, useMemo, useState } from 'react'
import { getFullDisplayBalance } from 'utils/formatBalance'

interface DepositModalProps {
  max: BigNumber
  onConfirm: (amount: string) => void
  onDismiss?: () => void
  tokenName?: string
  depositFeeBP?: number
  note?: string
}

const DepositModal: React.FC<DepositModalProps> = ({
  max,
  onConfirm,
  onDismiss,
  tokenName = '',
  depositFeeBP = 0,
  note,
}) => {
  const [val, setVal] = useState('')
  const [err, setErr] = useState('')
  const [pendingTx, setPendingTx] = useState(false)
  const TranslateString = useI18n()
  const fullBalance = useMemo(() => {
    return getFullDisplayBalance(max, 0)
  }, [max])

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      setVal(e.currentTarget.value)
    },
    [setVal],
  )

  const handleSelectMax = useCallback(() => {
    setVal(fullBalance)
  }, [fullBalance, setVal])

  return (
    <Modal title={`${TranslateString(316, 'Deposit')} ${tokenName} Tokens`} onDismiss={onDismiss}>
      <TokenInput
        value={val}
        onSelectMax={handleSelectMax}
        onChange={handleChange}
        max={fullBalance}
        symbol={tokenName}
        depositFeeBP={depositFeeBP}
      />
      {!!note && (
        <span style={{ color: '#4e598c', margin: '8px 0', fontStyle: 'italic', fontWeight: 'bold' }}>{note}</span>
      )}

      {!!err && <span style={{ color: 'red' }}>{err}</span>}
      <ModalActions>
        <Button variant="secondary" onClick={onDismiss}>
          {TranslateString(462, 'Cancel')}
        </Button>
        <Button
          disabled={pendingTx}
          onClick={async () => {
            try {
              setErr('')
              setPendingTx(true)
              await onConfirm(val)
              setPendingTx(false)
              onDismiss()
            } catch (error) {
              setPendingTx(false)
              let errMessage = error?.message
              if (!errMessage || !errMessage.includes('by user')) {
                errMessage = 'Error, please try again later!'
              }
              setErr(errMessage)
            }
          }}
        >
          {pendingTx ? `${TranslateString(488, 'Pending Confirmation')}...` : TranslateString(464, 'Confirm')}
        </Button>
      </ModalActions>
    </Modal>
  )
}

export default DepositModal
